import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campBtNew: FaireAdCampaignEntity = {
  token: "camp_bt_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_by_together",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 15000,
  startedRunningAt: "2024-07-16",
  segmentMetrics: {
    numCustomersAcquired: 1283,
    salesDollars: 1524626,
    totalAdsSpendDollars: 127768,
    cpaDollars: 99.59,
    bestEstimateSalesDollars: 1907046,
    bestEstimateRoas: 14.93,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
